
import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'

import './pedido-volume-readonly.css'

const PedidoVolumeReadOnly = ({justificativa}) => (
    <div>
      <div className="negotiation-read-column">
        <span>{intl.get('stocks.timeline.justification')}</span>
        <span>{justificativa}</span>
      </div>
      <div className="negotiation-read-column">
        <span />
        <span />
      </div>
    </div>
);

PedidoVolumeReadOnly.propTypes = {
  justificativa: PropTypes.string.isRequired,
}

export default PedidoVolumeReadOnly
